// @flow
import React from "react"
import type { Notification } from "data/notifications/types"
import { NotificationTileWrap, NotificationText } from "./styled"
import Icon from "./Icon"
import { getText } from "./helpers"

type Props = {|
  notification: Notification,
  closing: boolean,
  onClick: Function,
|}

const NotificationTile = ({ onClick, closing, notification }: Props) => (
  <NotificationTileWrap
    onClick={onClick}
    closing={closing}
    type={notification.type}
  >
    <Icon type={notification.type} />
    <NotificationText>{getText(notification.text)}</NotificationText>
  </NotificationTileWrap>
)

export default NotificationTile



// WEBPACK FOOTER //
// ./src/AppComponent/Content/Notifications/NotificationTile/index.js